var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5241 15.8594C4.91771 15.3542 6.1108 13.6345 7.35136 11.861L8.67568 9.91205L9.80904 8.24409C9.9243 8.07447 9.92429 7.85166 9.80903 7.68204L7.22077 3.87343L4.65125 0.212741C4.55765 0.0793848 4.40494 0 4.24201 0H2.26008H0.980914C0.575902 0 0.338942 0.456343 0.571929 0.787631L1.88542 2.6553C2.91233 4.11583 4.14458 5.86361 4.62386 6.53959C5.10313 7.21557 5.49534 7.85614 5.49534 7.96306C5.49534 8.06998 4.25898 9.90674 2.74778 12.0447L0.535764 15.1739C0.30596 15.499 0.529759 15.9492 0.927657 15.9622L2.07903 16H4.21923C4.33881 16 4.4506 15.9537 4.5241 15.8594Z",
    fill: "#E5EAEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.12ad3ceb.svg";
export { ForwardRef as ReactComponent };